export default "__VITE_PUBLIC_ASSET__d8e7d3cc__"